export function validateRequired(value, ...rest) {
    let error;
    if (value === '' || value === undefined || value === false) {
        error = 'Required!';
    }
    return error;
}

export function validateEmail(value) {
    let error;
    if (!value) {
        error = 'Required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
        error = 'Invalid email address';
    }
    return error;
}
